export default __webpack_public_path__ + "static/media/640_store04-fr-mobile.5ad362cc.png";